/** Available protocols for proxy servers */
export enum ProxyServerProtocolEnum {
  /** HTTPS */
  HTTPS = 'HTTPS',
  /** SOCKS v5 */
  SOCKS5 = 'SOCKS5',
}
